import {Base64} from 'js-base64'
import {isIOS, isInWechat, isInAlipay, getSessionCache} from '../utils/'
import {Env} from '../env/'

const isLan = Env.Production

/**
 * @description 获取加密信息
 * @param {str} 字符串
 * @return {object} 对象
 */
function parseString(str) {
  let config
  try {
    let len = str.length
    config = JSON.parse(Base64.decode(str.substring(0, 10) + str.substring(11, len - 11) + str.substring(len - 10)))
  } catch (e) {
    config = {}
  }
  return config
}
// 解密出来的配置选项
const config = parseString(window.config)
// 判断是否为APP环境内
const isApp = Boolean((window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iOSFYDH) || window.JsManager)
const getEnv = isApp ? 'app' : (isInWechat() ? 'wx' : (isInAlipay() ? 'alipay' : 'h5'))
const inIOS = isIOS()

// App 内区分环境，H5外放渠道只需要配置一个就行
function getValue(ios, android, init) {
  let value = config[inIOS ? ios : android] || init
  return value
}
console.log('config', config)
export default {
  title: config.title || '',
  orderSuccessAdCode: getValue('ios_orderSuccessAdCode', 'az_orderSuccessAdcode', 'FZSAZZFCG_BOX'), // 支付成功广告code
  orderSuccessAdW: config.orderSuccessAdW || '864', // 支付成广告宽度  默认为 864
  orderSuccessAdH: config.orderSuccessAdH || '228', // 支付成功广告高度  默认为 228
  companyTel: config.companyTel || '4001050580', // 公司电话
  companyQQ: config.companyQQ || '1286774563', // 公司客服邮箱
  couponCenterURL: getValue('iosCouponCenterUrl', 'androidCouponCenterUrl', ''), // android优惠券中心URL
  shareTitle: config.shareTitle,
  shareText: config.shareText,
  shareLogo: config.shareLogo || 'https://www.phone580.com/xfolder/api/getfile?path=%2Fimgs%2Fhlquan%2Flogo512x512.png',
  openCouponCode: config.openCouponCode || 'OTT_MG_30', // 外放优惠券码
  refereeActivityId: config.refereeActivityId || '', // 推荐人活动id
  applicantActivityId: config.applicantActivityId || '', // 被推荐人活动id
  enableSchemeCache: config.enableSchemeCache ? config.enableSchemeCache === 'true' : false, //是否启用方案缓存
  userId: getValue('ios_loginUserId', 'az_loginUserId', '161260'), // 默认用户ID 323277
  channelId: getValue('IOS_CLIENT_TYPE', 'AZ_CLIENT_TYPE', 'KHD_QD'), // 渠道id
  clientVersionId: getValue('IOS_CLIENT_VERSION', 'AZ_CLIENT_VERSION', '2'), // 客户端id
  clientVersionIds: config.searchClientVersions || '2', // 支持多个客户端查询按 2,36 格式
  clientVersionNo: getValue('ios_clientVersionNo', 'az_clientVersionNo', ''), // 客户端版本号，无特殊需求可不填
  faqCode: config.faqCode || 'CJWT_FZSBOX', // 常见问题code
  appSecret: config.appSecret || 'AWSDCS', // 加密规则 无特殊不填 AWSDCS
  appKey: config.appKey || '00001', // 加密秘钥无特殊不填 00001
  payType: config.payType || 'SDK', // 支付方式 SDK填 SDK H5方式填写H5
  appId: getValue('ios_appId', 'az_appId', '44461EE991786C6A026054A791DC3CDD'), // 客户端支付appId
  modelId: config.modelId || 9, // 短信模板
  templateId: config.templateId || 14, // 短信模板
  registerFrom: config.registerFrom || 'FBSSJ_SYSTEM',
  cnzzId: config.cnzzId || '', // 统计ID 1276700497
  // 微信公众号授权链接
  wxUrl: config.wxUrl || '',
  wxAppId: config.wxAppId || '', // 'wxfb51d68edffc90e2', // 微信公众号的APPID
  // 微信公众号登录分配标识
  bindType: config.bindType || 5
  // 查询商品分类
  , productType: config.productType || 'ALL'
  // 查询商品业务分类
  , orderBusinessType: config.orderBusinessType || ''
  , noticeCode: (isApp ? config.noticeCodeApp : config.noticeCodeH5 ) || 'H5_KFD'
  // sku方案编号
  , schemeNo: config.schemeNo || '4cfb6f546c6b42529adadfd4635ef948'
  // 任务方案编号
  , taskNo: config.taskNo || ''
  // 行为编号
  , actionNo: config.actionNo || ''
  // 可领取优惠券授权码
  , authCode: getValue('ios_authCode', 'az_authCode', 'X0mw2irD')
  // 可领取优惠券授权码
  , authType: getValue('ios_authType', 'az_authType', 'FZS')
  , taskUrl: config.taskUrl || '' // 跳转活动地址
  , taskBtnText: config.taskBtnText || '马上开福袋'
  , srcType: config.srcType || 'physical' // 订单来源
  , indexUrl: config.indexUrl || getSessionCache('backIndexUrl') || '' // indexURL非本地址路由index，需要配置indexURL taskUrl和 indexUrl只能存在一个
  // 订单界面奖品领取
  , prizePeceive: config.prizePeceive || 'false'
  , env: getEnv // 是否为App
  // 微信小程序的channelAccountType
  , channelAccountType: config.channelAccountType || 'wx'
  // 微信小程序的渠道ID
  , wxMiniChannelId: config.wxMiniChannelId || 'XIAOCX'
  // 微信小程序的客户端ID
  , wxMiniClientVersionId: config.wxMiniClientVersionId || ''
  // 微信的渠道ID
  , wxChannelId: config.wxChannelId || ''
  // 微信的客户端ID
  , wxClientVersionId: config.wxClientVersionId || ''
  // 招行支付描述
  , cmbPayDesc: config.cmbPayDesc || ''
  // 是否展示招行支付，默认不展示
  , showCMBpay: config.showCMBpay || 'false'
  // 固定获取客户端ID和渠道ID
  , fixationVersionId: config.fixationVersionId || 'false'
  // 固定的建行支付码
  , cbcPaySubCode: config.cbcPaySubCode || 'CBCPAY_WALLET'
  , goBindBackCardUrl: config.goBindBackCardUrl? config.goBindBackCardUrl:(isLan ? 'https://pay.phone580.com/fzsccb/index.html#/' : 'http://test.s.phone580.com:8000/service/pay/jianhangclass2/#/')
  , goBindABCWalletUrl: config.goBindABCWalletUrl? config.goBindABCWalletUrl: (isLan ? 'https://pay.phone580.com/fzsccb/index.html#/abc/home' : 'http://test.s.phone580.com:8000/service/pay/jianhangclass2/#/abc/home') // 绑定农行钱包卡地址
  , goBindCiticWalletUrl: config.goBindCiticWalletUrl? config.goBindCiticWalletUrl: (isLan ? 'https://pay.phone580.com/fzsccb/index.html#/citic/home' : 'https://test.s.phone580.com/service/pay/jianhangclass2/#/citic/home') // 绑定中信钱包卡地址
  , goBindSPDBWalletUrl: config.goBindSPDBWalletUrl? config.goBindSPDBWalletUrl: (isLan ? 'https://pay.phone580.com/fzsccb/index.html#/spdb/home' : 'http://test.s.phone580.com/service/pay/jianhangclass2/#/spdb/home') // 绑定浦发钱包卡地址
  , prodKey: config.prodKey || (isLan ? 'walletpay001a8s8a97' : 'test-wallet-pay001')
  , consumerCode: config.consumerCode || '100005'// 建行钱包支付消费码
  , isCoupon: config.isCoupon || 'false' // 是否展示优惠券
  , template: config, // 所有的模板参数都暴露出来
  versionName: '',
  buyProcessShow: config.buyProcessShow ? config.buyProcessShow  === 'true' : false,
  huabeiPaySubCodeH5: config.huabeiPaySubCodeH5 || 'JH_HB_ALIPAY_H5',// 花呗二级支付H5
  huabeiPaySubCodeSDK: config.huabeiPaySubCodeSDK || 'JH_HB_ALIPAY_APP', // 花呗二级支付SDK
  payTag: config.payTag, // 免密
  fzsWalletPay: config.fzsWalletPay ? JSON.parse(config.fzsWalletPay) : {}, // 蜂助手钱包支付配置信息
  phoneInputDisabled: config.phoneInputDisabled ? config.phoneInputDisabled === 'true' : false, // 禁止输入充值号码,固定读用户登录的手机号
  isSetTracking: config.isSetTracking ? config.isSetTracking === 'true' : false, // 是否埋点蜂助手钱包促销商品
  needMatchClient: config.needMatchClient ? config.needMatchClient === 'true' : false, // 是否需要客户端id匹配限制
  isShowProductDetails: config.isShowProductDetails ? config.isShowProductDetails === 'true' : false // 展示商品详情
  , showABCWallet: config.showABCWallet ? config.showABCWallet === 'true' : false // 展示农行钱包支付

  , ABCPaySubCode: config.ABCPaySubCode || 'ABCPAY_H5' // 农行支付的二级code

  , showHuaWeipay: config.showHuaWeipay || 'true' // 华为支付展示
  
  , CZYPAYSubCode: config.CZYPAYSubCode || '' // 彩之云paycode，配置代表要展示彩之云
  , FRONTPAYMENTSubCode: config.FRONTPAYMENTSubCode || '' // 前台支付二级code不配置就取第一个
  , JHUNIVERSALPAYSubCode: config.JHUNIVERSALPAYSubCode || 'JH_UNIVERSALPAY' // 华融湘江支付二级code不配置就取第一个
  
  , showJHUNIVERSALPAY: config.showJHUNIVERSALPAY ? config.showJHUNIVERSALPAY === 'true' : false // 展示华融湘江支付
  , showFRONTPAYMENT: config.showFRONTPAYMENT ? config.showFRONTPAYMENT === 'true' : false // 展示前台支付
  , showCZYPAY: config.showCZYPAY ? config.showCZYPAY === 'true' : false // 展示彩之云支付


  , showSPDBWallet: config.showSPDBWallet ? config.showSPDBWallet === 'true' : false // 展示浦发钱包支付
  , showCITICWallet: config.showCITICWallet ? config.showCITICWallet === 'true' : false // 展示中信钱包支付
  , hideTwoPay: config.hideTwoPay ? config.hideTwoPay === 'true' : false // 隐藏订单界面的二次支付 true隐藏false不隐藏
  , storehouseCardUrl: config.storehouseCardUrl // 开通宝藏卡URL
  , onlyALIWXPay: config.onlyALIWXPay? config.onlyALIWXPay === 'true' : false // 只展示支付宝和微信
  , closeOrderTime: config.closeOrderTime // 关闭订单的倒计时

  , showFzsWalletPay: config.showFzsWalletPay? config.showFzsWalletPay === 'true' : false // 展示新钱包
  , showFzsWalletPayCCB: config.showFzsWalletPayCCB? config.showFzsWalletPayCCB === 'true' : false // 展示新钱包建行
  , showFzsWalletPayCITIC: config.showFzsWalletPayCITIC? config.showFzsWalletPayCITIC === 'true' : false // 展示新钱包中信
  , showFzsWalletPayABC: config.showFzsWalletPayABC? config.showFzsWalletPayABC === 'true' : false // 展示新钱包农行
  , showFzsWalletPaySPDB: config.showFzsWalletPaySPDB? config.showFzsWalletPaySPDB === 'true' : false // 展示新钱包浦发
  
}
